module.exports = __webpack_public_path__ + "static/media/clear-day.c03c1a72.jpeg";